import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  Input,
  Modal,
  Button,
  Form,
  Upload,
  Image,
  Select,
  Row,
  Col,
  Tabs,
  theme,
  Tag,
  Tooltip,
  Empty,
  Avatar,
} from "antd";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus, faUser } from "@fortawesome/free-solid-svg-icons";
import axios from "axios";
import { onCloseTracklist } from "../../../Redux/CreateUpdateTracklistSlice";
import "./CreateOrUpdateTrackListModal.css";

function CreateOrUpdateTrackListModal() {
  const dispatch = useDispatch();
  const { openList, infoList, listType } = useSelector(
    (state) => state.createUpdateTracklist
  );
  const [form] = Form.useForm();
  const [allValidated, setAllValidated] = useState(false);
  const [tempData, setTempData] = useState({});
  const [preview, setPreview] = useState({ src: "", open: false });
  const [genres, setGenres] = useState([]);
  const [activeTab, setActiveTab] = useState("1");
  const tabItems = [
    {
      label: <span className="profileTabLabel">Thông tin cơ bản</span>,
      key: "1",
      children: BasicInfoFields(form, preview, setPreview, genres),
    },
    {
      label: <span className="profileTabLabel">Danh sách track</span>,
      key: "2",
      children: TracklistFields(),
    },
  ];

  useEffect(() => {
    const getGenres = async () => {
      try {
        const res = await axios.get(
          process.env.REACT_APP_SERVER_URL + "/genre/get-all"
        );
        const genres = res.data.map((genre) => ({
          label: genre.name,
          value: genre._id,
        }));
        setGenres(genres);
      } catch (err) {
        console.error("Error fetching genres:", err);
      }
    };
    if (genres.length === 0) {
      getGenres();
    }
  }, []);

  useEffect(() => {
    if (openList) {
      document.body.classList.add("tracklist-modal-open");
    } else {
      document.body.classList.remove("tracklist-modal-open");
    }
    return () => {
      document.body.classList.remove("tracklist-modal-open");
    };
  }, [openList]);

  useEffect(() => {
    if (openList && infoList) {
      form.setFieldsValue(infoList);
    }
    return () => form.resetFields();
  }, [openList, infoList, form]);

  useEffect(() => {
    const validate = async () => {
      try {
        await form.validateFields();
        setAllValidated(true);
      } catch (err) {
        console.log(err);
      }
    };
    validate();
  }, [tempData, form]);

  const handleAddUpdateTrack = async () => {
    if (allValidated) {
      const data = form.getFieldsValue();
      const formData = new FormData();
      if (data.avatar) {
        formData.append("image", data.avatar);
      }
      formData.append("privacy", data.privacy);
      formData.append("title", data.title);
      formData.append("genre", data.genre);
      formData.append("tags", data.additionTags);
      formData.append("description", data.description);

      try {
        const res = await axios.post(
          process.env.REACT_APP_SERVER_URL + "/track/create",
          formData,
          {
            headers: { "Content-Type": "multipart/form-data" },
          }
        );
        // res.data.url
        if (res.status === 201) {
          alert("Upload successfully");
          handleClose();
        }
      } catch (err) {
        console.error("Upload error: ", err);
        alert("Upload failed");
      }
      handleClose();
    }
  };

  const handleClose = () => {
    form.resetFields();
    setPreview({ src: "", open: false });
    setTempData({});
    setAllValidated(false);
    dispatch(onCloseTracklist());
  };

  return (
    <>
      <Modal
        className="uploadUpdateTrackModal tracklistModal"
        open={openList}
        title={infoList ? `Cập nhật ${listType}` : `Tạo ${listType}`}
        onCancel={handleClose}
        footer={
          <>
            <Button
              disabled={!allValidated}
              htmlType="submit"
              onClick={handleAddUpdateTrack}
              type="primary"
            >
              {infoList ? "Lưu thay đổi" : "Tạo tracklist"}
            </Button>
            <Button onClick={handleClose}>Hủy</Button>
          </>
        }
      >
        <div className="trackModalWrapper">
          <Form
            layout={activeTab === "1" ? "vertical" : "horizontal"}
            form={form}
            initialValues={
              {
                privacy: "private",
                ...infoList,
              } || {}
            }
            onValuesChange={(_, values) => setTempData(values)}
          >
            <Tabs
              defaultActiveKey="1"
              items={tabItems}
              onChange={(key) => setActiveTab(key)}
            />
          </Form>
        </div>
      </Modal>
    </>
  );
}

function BasicInfoFields({ form, preview, setPreview, genres }) {
  const getBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });
  };
  const handlePreview = async (file) => {
    if (!file.url && !file.preview) {
      file.preview = await getBase64(file.originFileObj);
    }
    setPreview({ src: file.url || file.preview, open: true });
  };
  return (
    <>
      <Form.Item
        label="Ảnh đại diện:"
        name="avatar"
        getValueFromEvent={(e) => e?.fileList}
        rules={[
          {
            validator(_, fileList) {
              return new Promise((resolve, reject) => {
                if (fileList && fileList[0]?.size > 5 * 1024 * 1024) {
                  reject("Kích cỡ file đã vượt quá 5MB");
                } else {
                  resolve();
                }
              });
            },
          },
        ]}
      >
        <div>
          <Upload
            listType="picture-card"
            maxCount={1}
            accept=".jpg,.jpeg,.png,.svg"
            onPreview={handlePreview}
            onChange={(data) =>
              form.setFieldValue(
                "avatar",
                data?.fileList[0]?.originFileObj || null
              )
            }
            beforeUpload={() => false} // Disable auto upload
          >
            <button className="uploadTrackAvatarBtn">
              <FontAwesomeIcon icon={faPlus} />
              <span>Chọn ảnh</span>
            </button>
          </Upload>
          {preview?.src && (
            <Image
              wrapperStyle={{
                display: "none",
              }}
              preview={{
                visible: preview?.open,
                onVisibleChange: (visible) =>
                  setPreview((prev) => ({ ...prev, open: visible })),
                afterOpenChange: (visible) =>
                  !visible && setPreview((prev) => ({ ...prev, src: "" })),
              }}
              src={preview?.src}
            />
          )}
        </div>
      </Form.Item>
      <Form.Item
        label="Tiêu đề"
        name="title"
        rules={[{ required: true, message: "Thông tin không được để trống" }]}
      >
        <Input placeholder="Tên tiêu đề" />
      </Form.Item>
      <Row gutter={[16, 16]}>
        <Col span={12}>
          <Form.Item
            label="Dòng nhạc:"
            name="genre"
            rules={[
              {
                required: true,
                message: "Thông tin không được để trống",
              },
            ]}
          >
            <Select
              size="small"
              options={genres}
              placeholder="Chọn dòng nhạc"
            />
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item label="Bổ sung tag:" name="additionTags">
            <Select
              size="small"
              showSearch
              mode="tags"
              options={genres?.map((genre) => ({
                label: genre.label,
                value: genre.label,
              }))}
              placeholder="Thêm tag"
            />
          </Form.Item>
        </Col>
      </Row>
      <Form.Item label="Miêu tả:" name="description">
        <Input.TextArea
          placeholder="Miêu tả"
          autoSize={{ minRows: 1, maxRows: 5 }}
          count={{ show: true, max: 5000 }}
        />
      </Form.Item>
    </>
  );
}

function TracklistFields() {
  const tagInputStyle = {
    width: 64,
    height: 22,
    marginInlineEnd: 8,
    verticalAlign: "top",
  };
  const { token } = theme.useToken();
  const [tags, setTags] = useState([]);
  const [inputVisible, setInputVisible] = useState(false);
  const [inputValue, setInputValue] = useState("");
  const inputTrackRef = useRef(null);

  useEffect(() => {
    if (inputVisible) {
      inputTrackRef?.current?.focus();
    }
  }, [inputVisible === true]);

  const handleClose = (removedTag) => {
    const newTags = tags.filter((tag) => tag !== removedTag);
    console.log(newTags);
    setTags(newTags);
  };
  const showInput = () => {
    setInputVisible(true);
  };
  const handleInputChange = (e) => {
    setInputValue(e.target.value);
  };
  const handleInputOut = () => {
    setInputVisible(false);
  };
  const handleChooseConfirm = (title) => {
    if (title && !tags.includes(title)) {
      setTags([...tags, title]);
    }
    setInputVisible(true);
    setInputValue("");
    inputTrackRef.current?.focus();
  };
  const removeNewestTag = () => {
    const newTags = tags.slice(0, tags.length - 1);
    setTags(newTags);
  };
  const tagPlusStyle = {
    height: 22,
    background: token.colorBgContainer,
    borderStyle: "dashed",
  };
  return (
    <>
      <Form.Item label="Danh sách track:" name="tracklist">
        {tags.map((tag, index) => {
          const isLongTag = tag.length > 20;
          const tagElem = (
            <Tag
              key={tag}
              closable={index >= 0}
              style={{
                userSelect: "none",
              }}
              onClose={() => handleClose(tag)}
            >
              <span>{isLongTag ? `${tag.slice(0, 20)}...` : tag}</span>
            </Tag>
          );
          return isLongTag ? (
            <Tooltip title={tag} key={tag}>
              {tagElem}
            </Tooltip>
          ) : (
            tagElem
          );
        })}
        {inputVisible ? (
          <Input
            ref={inputTrackRef}
            type="text"
            size="small"
            style={tagInputStyle}
            value={inputValue}
            onChange={handleInputChange}
            onBlur={handleInputOut}
            // onPressEnter={handleInputOut}
            onKeyDown={(e) => {
              if (e.key === "Backspace" && inputValue === "") {
                if (tags.length > 0) {
                  removeNewestTag();
                }
              }
            }}
          />
        ) : (
          <Tag
            style={tagPlusStyle}
            icon={<FontAwesomeIcon icon={faPlus} />}
            onClick={showInput}
          >
            Thêm track
          </Tag>
        )}
      </Form.Item>
      <div className="groupBody">
        <Empty description="Không tìm thấy track nào" />
        {[...Array(10)].map((_, index) => (
          <Row
            onClick={() => handleChooseConfirm(`name of someone ${index}`)}
            className="groupUserResult"
          >
            <Col span={4} className="groupUserResultContent avatar">
              <Avatar icon={<FontAwesomeIcon icon={faUser} />} />
            </Col>
            <Col span={20} className="groupUserResultContent">
              <span>name of someone {index}</span>
            </Col>
          </Row>
        ))}
      </div>
    </>
  );
}

export default CreateOrUpdateTrackListModal;
